import { Page } from '@/core/architecture'

import { GlobalHomeTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * GlobalHome Page
 * Implemented as a practical sample.
 */
export const GlobalHome: Page = () => {
  const { state, actions } = useViewModel()

  return <GlobalHomeTemplate state={state} {...actions} />
}
